import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable, Observer } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class WebSocketService {

    public socket!: WebSocket;

    public initializeSocket(streamUrl: string): Observable<Event> {
        this.socket = new WebSocket(streamUrl);
        // this.socket = new WebSocket(`${environment.socketEndpoint}`);
        this.socket.binaryType = "arraybuffer";

        return new Observable((observer: Observer<Event>) => {
            this.socket.addEventListener("open", (event: Event) => {
                observer.next(event);
            });

            return () => {
                this.socket.close();
            };
        });
    }

    public heartbeat() {
        if (!this.socket) return;
        if (this.socket.readyState !== 1) return;
        this.emit('heartbeat', {});
        setTimeout(this.heartbeat.bind(this), 500);
      }

    public off(eventName: string) {
        // Not needed for WebSocket API
    }

    public emit(eventName: string, body: any) {
        console.log(eventName, body);
        
        if(this.socket) {
            this.socket.send(JSON.stringify({ event: eventName, ...body }));
        }
    }

    public disconnect() {
        if(this.socket) {
            this.socket.close();
        }
    }
}